import { post } from "../index";

// POST /posts/:id/retry — re-emits POST_APPROVED on the outbox with a
// fresh dedupeKey so the worker re-attempts publish on every platform
// that hasn't already succeeded. The worker side (socialPostingProcessor)
// skips platforms already present in postingResults.success, so a
// partially-posted post won't duplicate the ones that worked.
export const retryPost = (postId) => post(`/posts/${postId}/retry`, {});
